if (!customElements.get('announcement-ticker')) {
  class AnnouncementTicker extends HTMLElement {
    connectedCallback() {
      this.marquee = this.querySelector('[data-ticker-marquee]');
      this.template = this.querySelector('[data-ticker-template]');

      if (!this.marquee || !this.template) return;

      this.cycleHTML = this.template.innerHTML.trim();
      this.speed = parseInt(this.dataset.speed, 10) || 30;

      this.build();

      this._resizeObserver = new ResizeObserver(() => this.build());
      this._resizeObserver.observe(this);

      this._sectionListener = (event) => {
        if (event.target.contains(this)) {
          const nextTemplate = this.querySelector('[data-ticker-template]');
          if (nextTemplate) {
            this.cycleHTML = nextTemplate.innerHTML.trim();
          }
          this.build();
        }
      };

      document.addEventListener('shopify:section:load', this._sectionListener);
    }

    disconnectedCallback() {
      this._resizeObserver?.disconnect();
      if (this._sectionListener) {
        document.removeEventListener('shopify:section:load', this._sectionListener);
      }
    }

    build() {
      if (!this.cycleHTML) return;

      const containerWidth = this.offsetWidth;
      if (!containerWidth) return;

      this.marquee.innerHTML = '';

      const strip = document.createElement('div');
      strip.className = 'announcement-ticker__strip';
      strip.innerHTML = this.cycleHTML;
      this.marquee.appendChild(strip);

      let safety = 0;
      while (strip.offsetWidth < containerWidth && safety < 20) {
        strip.insertAdjacentHTML('beforeend', this.cycleHTML);
        safety += 1;
      }

      const duplicate = strip.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      this.marquee.appendChild(duplicate);

      const shift = strip.offsetWidth;
      this.marquee.style.setProperty('--announcement-ticker-shift', `-${shift}px`);
      this.marquee.style.setProperty('--announcement-ticker-duration', `${this.speed}s`);
    }
  }

  customElements.define('announcement-ticker', AnnouncementTicker);
}
